export default "__VITE_ASSET__7e106631__"